import { useQuery } from '@tanstack/react-query';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import request from '@teetsh/app/src/utils/request';
import { edtDeserializer } from '@teetsh/app/src/queries/edt/serializer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export const EDT_KEY = 'edt';

function fetchEDTs({
  schoolyearId,
  schoolId,
  location,
}: {
  schoolyearId: string;
  schoolId: string;
  location: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/emplois-du-temps`;
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: any[] }) =>
    (data || []).map(d => edtDeserializer(d, location)),
  );
}

interface Props {
  enabled: boolean;
}

export default function useEDTs({ enabled }: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  return useQuery({
    queryKey: [schoolyear.id, school.id, EDT_KEY, 'list'],
    queryFn: () =>
      fetchEDTs({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        location: user.location,
      }),

    placeholderData: [],
    enabled,
    refetchOnWindowFocus: false,
  });
}
